import { createApiSlice } from 'app/createApiSlice'
import {
  API_WAREHOUSE,
  API_WAREHOUSE_NETWORK_ITEMS,
  API_WAREHOUSE_NETWORK_SUMMARY,
} from 'utils/apiList'

export const inventoriIntelligentApiSlice = createApiSlice.injectEndpoints({
  reducerPath: 'inventoriIntelligent/api',
  endpoints(builder) {
    return {
      fetchWarehouseNetworkById: builder.query({
        query({ id, userIdParam }) {
          if (!id) {
            throw new Error("Parameter 'warehouseId' is mandatory!.")
          }
          return {
            url: `${API_WAREHOUSE}/network`,
            params: {
              id,
              ...(userIdParam ? { userId: userIdParam } : {}),
            },
          }
        },
      }),
      fetchInventoriIntelligent: builder.query({
        query({ page, size = 10, sortby, sortdir, s, owned, itemIds }) {
          const params = {
            page,
            size,
            sortby,
            sortdir,
            s: s ?? '',
          }

          if (owned !== undefined && owned !== null) {
            params.owned = owned
          }

          if (itemIds && itemIds.length > 0) {
            params.itemIds = itemIds
          }

          return {
            url: `${API_WAREHOUSE}/network`,
            params,
          }
        },
      }),

      fetchWarehouseById: builder.query({
        query({ id }) {
          if (!id) {
            throw new Error("Parameter 'warehouseId' is mandatory!.")
          }
          return {
            url: API_WAREHOUSE,
            params: {
              id,
            },
          }
        },
      }),

      fetchWarehouseNetworkSummary: builder.query({
        query({
          page = 0,
          size = 10,
          sortby = 'total',
          sortdir = 'asc',
          warehouseId,
          month,
          type = 'current',
          groupId,
          from,
          to,
          all,
          ownerUserId,
          itemIds,
        }) {
          return {
            url: API_WAREHOUSE_NETWORK_SUMMARY,
            params: {
              page,
              size,
              sortby,
              sortdir,
              warehouseId,
              month,
              type,
              ...(groupId ? { groupId } : {}),
              ...(from ? { from } : {}),
              ...(to ? { to } : {}),
              ...(all ? { all } : {}),
              ...(ownerUserId ? { ownerUserId } : {}),
              ...(itemIds && { itemIds }),
            },
          }
        },
      }),

      fetchWarehouseNetworkItems: builder.query({
        query({ page = 0, size = 9999 }) {
          return {
            url: API_WAREHOUSE_NETWORK_ITEMS,
            params: {
              page,
              size,
            },
          }
        },
      }),
    }
  },
})

export const {
  useFetchInventoriIntelligentQuery,
  useFetchWarehouseNetworkByIdQuery,
  useFetchWarehouseNetworkSummaryQuery,
  useLazyFetchWarehouseNetworkSummaryQuery,
  useFetchWarehouseNetworkItemsQuery,
} = inventoriIntelligentApiSlice
